const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getAssets(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.status) params.append('status', filters.status);
  if (filters.program) params.append('program', filters.program);
  if (filters.owner) params.append('owner', filters.owner);
  if (filters.search) params.append('search', filters.search);
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/assets${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view assets');
    }
    throw new Error('Failed to fetch assets');
  }
  
  return response.json();
}

export async function getAsset(orgId, assetId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/assets/${assetId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Asset not found');
    }
    if (response.status === 403) {
      throw new Error('You do not have permission to view this asset');
    }
    throw new Error('Failed to fetch asset');
  }
  
  const data = await response.json();
  return data.asset;
}
